import styled, { css } from 'astroturf/react';
import Checkbox from 'src/components/Checkbox';

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  padding: 5% 10%;
  max-height: 90vh;
  overflow: auto;
  row-gap: 4rem;
`;

const ResultSelectionSection = styled('section')`
  display: flex;
  width: 100%;
  column-gap: 3%;
`;

const ResponseFingerprintSection = styled('section')`
  display: grid;
  grid-template-rows: 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-template-columns: 1fr 1fr;
  column-gap: 20px;
  row-gap: 10px;
`;

const responderTimezone = css`
  grid-column-start: 1;
  grid-row-start: 2;
`;

const surveyStartedAt = css`
  grid-column-start: 1;
  grid-row-start: 3;
`;

const lastActivity = css`
  grid-column-start: 1;
  grid-row-start: 4;
`;

const responderOs = css`
  grid-column-start: 1;
  grid-row-start: 5;
`;

const browser = css`
  grid-column-start: 1;
  grid-row-start: 6;
`;

const surveyFinishedAt = css`
  grid-column-start: 2;
  grid-row-start: 3
`;

const QuestionResponseSection = styled('section')`
  display: flex;
  flex-direction: column;
  pointer-events: none;
`;

const QuestionPictureCheckboxWrapper = styled(Checkbox)`
  color: var(--black);
  padding: 0 0 0 30px;

    label {
      left: -15px;
    }
`;

export default {
  Container,
  ResultSelectionSection,
  ResponseFingerprintSection,
  responderTimezone,
  surveyStartedAt,
  surveyFinishedAt,
  lastActivity,
  responderOs,
  browser,
  QuestionResponseSection,
  QuestionPictureCheckboxWrapper
};
